import { EMPLOYEE_CONTRACT_TYPES_ALIASES } from './contractTypes';

export const isB2BContract = (contractType: string) => EMPLOYEE_CONTRACT_TYPES_ALIASES.B2B.toString() === contractType;

export const isCFSContract = (contractType: string) => EMPLOYEE_CONTRACT_TYPES_ALIASES.CFS.toString() === contractType;

export const isContractorContract = (contractType: string) =>
  isB2BContract(contractType) || isCFSContract(contractType);

export const isEmployeeContractByType = (contractType: string) =>
  EMPLOYEE_CONTRACT_TYPES_ALIASES.EC.toString() === contractType;
